"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=require("../styles/theme.js");const b={medium:a.theme.customHeights.regularButton,small:a.theme.customHeights.smallButton};exports.SIZE=b
//# sourceMappingURL=constants.js.map
